import React from 'react';

export const Roadmap: React.FC = () => {
    const roadmapItems = [
        {
            status: 'completed',
            icon: '✅',
            title: 'Telegram Alert Bot',
            description: 'Core monitoring and alert system'
        },
        {
            status: 'upcoming',
            icon: '🔜',
            title: 'Auto-stake + Exit Logic',
            description: 'Automated position management'
        },
        {
            status: 'upcoming',
            icon: '🔜',
            title: 'Strategy Templates',
            description: 'Pre-built strategies like "New Pool Sniper"'
        },
        {
            status: 'upcoming',
            icon: '🔜',
            title: 'Performance Leaderboard',
            description: 'Track top-performing strategies'
        },
        {
            status: 'upcoming',
            icon: '🔒',
            title: 'Optional Vaults',
            description: 'Passive farming opportunities'
        }
    ];

    return (
        <section id="roadmap" className="py-24 bg-gradient-to-b from-black to-purple-900/10">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                    <span className="inline-block px-6 py-3 bg-purple-500/10 border border-purple-500/30 rounded-full text-purple-300 text-lg font-semibold mb-4">
                        🧭 Roadmap
                    </span>
                    <h2 className="text-5xl md:text-6xl font-bold text-white">
                        Post-Validation{' '}
                        <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
                            Development
                        </span>
                    </h2>
                </div>

                <div className="relative">
                    {/* Timeline line */}
                    <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-gradient-to-b from-purple-500 to-pink-500"></div>

                    <div className="space-y-8">
                        {roadmapItems.map((item, index) => (
                            <div key={index} className="relative flex items-start">
                                <div className={`
                                    relative z-10 flex items-center justify-center w-16 h-16 rounded-full text-2xl
                                    ${item.status === 'completed' 
                                        ? 'bg-green-500/20 border-2 border-green-500' 
                                        : 'bg-purple-500/20 border-2 border-purple-500'}
                                `}>
                                    {item.icon}
                                </div>
                                <div className="ml-8 flex-1">
                                    <div className={`
                                        p-6 rounded-xl border
                                        ${item.status === 'completed'
                                            ? 'bg-green-500/5 border-green-500/30'
                                            : 'bg-purple-500/5 border-purple-500/30'}
                                    `}>
                                        <h3 className="text-xl font-semibold text-white mb-2">{item.title}</h3>
                                        <p className="text-gray-400">{item.description}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};